import classNames from 'classnames'
import styles from './index.less'
import { history, useRouteProps } from 'umi'
import createRoutes from '@/routes/createRoutes'
import goToRoute from '@/utils/goToRoute'
import ToolsMenu from '../ToolsNavPopup/CreatePlatformToolsNav'
import { useBasePlatform,useStore } from '@/states/store';
import { useMemo } from 'react';

const [{ routes }] = createRoutes
const menus = routes.filter(o => o.meta?.menu !== false)
const { UMI_ENV } = process.env

export default () => {
  const router = useRouteProps()
  const { baseSnap } = useBasePlatform();
  
  const _menus = useMemo(() => {
    return menus.filter((_: any) => !baseSnap.oemInfos?.hideMenuPaths?.includes(_.path));
  }, [baseSnap.oemInfos]);
  const { userInfo } = useStore()

  const renderMenu = () => {
    return (
      <div className={styles.wrapper}>
        {_menus.map(item => {
          return (
            <div
              key={item.path}
              className={classNames([styles.menuItem, { [styles.active]: router.path.includes(item.path) }])}
              onClick={() => goToRoute(item.path, (item.path.includes('marketing-poster') && userInfo?.specialInfo?.g3 === 'A') ? undefined : item.meta?.check)}
            >
              {item.name}
            </div>
          )
        })}
        {/* AI工具箱菜单 */}
        <ToolsMenu />
        {UMI_ENV !== 'online' && baseSnap.userInfo.oemFlag!==1 && (
          <div
            key={'/create/posterTemplate'}
            className={classNames([styles.menuItem, { [styles.active]: router.path.includes('/create/posterTemplate') }])}
            onClick={() => goToRoute('/create/posterTemplate')}
          >
            海报模版
          </div>
        )}
        {UMI_ENV !== 'online' && baseSnap.userInfo.oemFlag!==1 && (
          <div
            key={'/my-creations'}
            className={classNames([styles.menuItem, { [styles.active]: router.path.includes('/my-creations') }])}
            onClick={() => goToRoute('/my-creations?tab=2')}
          >
            我的草稿
          </div>
        )}
      </div>
    )
  }

  return <div>{renderMenu()}</div>
}
